export const CONF = {
  NETLIFY_FUNCTIONS_BASE: '/.netlify/functions/',
};
